import { VehiclesRepository } from "src/containers/vehicles/repositories/vehicles/vehicles-repository";
import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { autoBind } from "src/shared/decorators/autobind";
import { DayjsUtils } from "src/libs/dayjs-utils";
import { VehicleTracking } from "src/shared/models/vehicle-tracking.model";
import { Vehicle } from "src/shared/models/vehicle.model";

@injectable()
export class VehiclesService {
    constructor(
        @inject("VehiclesRepository") private repository: VehiclesRepository
    ) {}

    @autoBind
    getTracking(
        userIdentity: string,
        systemCode: string,
        policyId: number,
        dateRange: string = DayjsUtils.today().format("YYYY-MM-DD")
    ): Observable<VehicleTracking> {
        return this.repository
            .getTracking(userIdentity, systemCode, policyId, dateRange)
            .pipe(
                map(
                    (data) =>
                        data.map((t) =>
                            VehicleTracking.fromJson<VehicleTracking>(t)
                        )[0]
                )
            );
    }

    @autoBind
    getFirstVehicle(
        userIdentity: string,
        systemCode: string,
        policyId: number
    ): Observable<Vehicle> {
        return this.repository
            .getFirstVehicle(userIdentity, systemCode, policyId)
            .pipe(map((vehicles) => Vehicle.fromJson<Vehicle>(vehicles[0])));
    }
}
